import mimeStartsWith from 'utils/mimeStartsWith';

const isPicture = object => mimeStartsWith(object, 'image/');

export default isPicture;
